import React, { useContext, useMemo } from 'react'
import { useNavigate } from 'react-router-dom';
import axiosService from '../../../../utils/AxiosService';
import { CurrentProjectManagerContext } from '../../../../contexts/CurrentProjectManagerContext';
import { Pencil, Trash } from 'react-bootstrap-icons';
import { toastError } from '../../../FormComponents/Toasts';

export default function ProjectManagerItem({ projectManager, getProjectManagers }) {
  const navigate = useNavigate()
  const { currentProjectManager } = useContext(CurrentProjectManagerContext)

  const isAdmin = useMemo(() => projectManager.is_admin ? 'Yes' : 'No', [projectManager.id])

  const deleteProjectManager = () => {
    axiosService.delete(`/api/project_manager/project_managers/${projectManager.id}`)
    .then(() => getProjectManagers())
    .catch(({ data: { error } }) => toastError(error))
  }

  return (
    <tr className="bg-white dark:bg-rb-dark-mode-lighter border-rb-green dark:border-rb-green border-2">
      <td className="w-40 p-4 border-rb-green dark:border-rb-green border-r-2 dark:text-white">{projectManager.id}</td>
      <td className="w-40 p-4 border-rb-green dark:border-rb-green border-r-2 dark:text-white">{projectManager.email}</td>
      <td className="w-40 p-4 border-rb-green dark:border-rb-green border-r-2 dark:text-white">{isAdmin}</td>
      <td>
        <div className="grid grid-cols-4 justify-items-center">
          <button className="flex justify-center h-8 items-center col-start-2 w-8 text-rb-green dark:text-rb-green p-1 active:shadow-outer active:shadow-rb-green active:bg-rb-green active:text-white dark:active:text-rb-dark-mode rounded-full" onClick={() => navigate(`/project_manager/project-managers/${projectManager.id}`)}><Pencil /></button>
          {currentProjectManager.id !== projectManager.id && <button className="flex justify-center h-8 items-center w-8 col-start-3 text-red-400 dark:text-red-400 p-1 active:shadow-outer active:shadow-red-400 active:bg-red-400 active:text-white dark:active:text-rb-dark-mode rounded-full" onClick={deleteProjectManager}><Trash /></button>}
        </div>
      </td>
    </tr>
  )
}